import React, { useContext, useState } from 'react';
import { BackendService } from '../backend/BackendService';
import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import { threadId } from 'worker_threads';
import { Function } from '../backend/generated-rest-client';
import { FlowFlags } from 'typescript';

export interface ILoginCallback {
    onSuccess: (navi: string) => void;
    onFailure: (err: string) => void;
}

export interface IFunctionCallback {
    onFuncSuccess: (funcList: Function[]) => void;
    onFuncFailure: (err: string) => void;
}

type ContextValueType = {
    login: (
        userName: string, password: string, authcode: string, callbacks: ILoginCallback
        ) => Promise<void>,
    logout: () => Promise<void>,
    init: ()=> void,
    userName: string,
    idToken: string,
    isLoggedIn: boolean,
    isAvailableFunc: (target: string, funcList:Function[]) => boolean,
    availableFunction: (idToken: string, callbacks: IFunctionCallback) => Promise<void>,
}

export const UserContext = React.createContext<ContextValueType>({} as ContextValueType);

export const useUserContext = () => useContext(UserContext);

type Props = {
    children?: React.ReactNode;
};
export const UserContextProvider: React.FC<Props> = ({ children }) => {
    const [idToken, setIdToken] = useState<string>('');
    const [userName, setUserName] = useState<string>('');
    const [cognitoUser, setCognitoUser] = useState<AmazonCognitoIdentity.CognitoUser>();

    const poolData = {
        UserPoolId: process.env.REACT_APP_USER_POOL_ID ? process.env.REACT_APP_USER_POOL_ID : '',
        ClientId: process.env.REACT_APP_CLIENT_ID ? process.env.REACT_APP_CLIENT_ID : '',
    };

    const contextValue: ContextValueType = {
        login: async (userName: string, password: string, authcode: string, callbacks: ILoginCallback) => {
            console.log("login start");
            console.log("login userPoolId[" + poolData.UserPoolId + "], clientId[" +  poolData.ClientId + "]");
            const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

            console.log("login AmazonCognitoIdentity.CognitoUserPool");
            // ログイン認証の対象とするCognito User Poolとユーザを設定する
            let userData = {
                Username: userName,
                Pool: userPool,
            };
            let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

            console.log("login AmazonCognitoIdentity.CognitoUser");
            // 認証用に渡すusernameとpasswordを設定する
            let authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
                {
                    Username: userName,
                    Password: password,
                }
            );

            console.log("login AmazonCognitoIdentity.AuthenticationDetails");
            // ログイン認証を実行する
            try {
                cognitoUser.authenticateUser(authenticationDetails, {
                    onSuccess: function (result) {
                        // ログイン成功時の処理を実装する
                        console.log("Login Success");
                        console.log(result);
                        console.log(
                            "Access Token(jwtToken)=" + result.getAccessToken().getJwtToken()
                        );
                        console.log("ID Token(jwtToken)=" + result.getIdToken().getJwtToken());
                        console.log("Refresh Token=" + result.getRefreshToken().getToken());
                        console.log(
                            "username(congitoの一意ID)=" +
                            result.getAccessToken().decodePayload().username
                        );

                        setCognitoUser(cognitoUser);

                        let ret2 = BackendService.login(result.getIdToken().getJwtToken())
                        .then(response => {
                            console.log("BackendService.login :then");
                            console.log(response);
                            setUserName(userName);
                            // setIdToken(result.getIdToken().getJwtToken());
                            const new_idToken = result.getIdToken().getJwtToken();
                            // callbacks.onSuccess();

                            //利用可能機能を取得する
                            contextValue.availableFunction(new_idToken, {
                                onFuncSuccess: function (funcList) {
                                    setIdToken(result.getIdToken().getJwtToken());
                                    let navi = funcList.at(0)?.functionId;
                                    if (navi != null) {
                                        callbacks.onSuccess(navi);
                                    }
                                },
                                onFuncFailure: function (err) {
                                    // setIdToken('');
                                    callbacks.onFailure(err);
                                }
                            })
                        })
                        .catch(error => {
                            console.log("BackendService.login :catch");
                            console.log(error);
                            callbacks.onFailure('System Error; Contact your system administrator.');
                        });
                        console.log(ret2);                            
                    },
                    newPasswordRequired: function (userAttributes, requiredAttributes) {
                        // 初回パスワード変更は、管理者で行う想定なので行われていなければ、システムエラー。
                        console.log('password change');
                        callbacks.onFailure('System Error; Contact your system administrator.');
                        //cognitoUser.completeNewPasswordChallenge(password, {}, this);
                        //callbacks.onFailure('initial password set. try agein.');
                    },
                    mfaSetup: function (challengeName, challengeParameters) {
                        // MFAの設定は、管理者で行う想定なので行われていなければ、システムエラー。
                        console.log('mfaSetup');
                        callbacks.onFailure('System Error; Contact your system administrator.');
                        // cognitoUser.associateSoftwareToken(
                        //     {
                        //         associateSecretCode: function (secretCode) {
                        //             // MFA有効化されていてTOTP初回認証時に発生します
                        //             // SecretCodeが発行されるので、Google Authenticatorなどに登録できるよう
                        //             // QRコードを生成します。(シークレットコードを手動入力するのもあり)
                        //             console.log('associateSecretCode');
                        //             console.log('MFA有効化されていてTOTP初回認証時に発生します');

                        //             // QRコードを生成してターミナルに表示
                        //             let url = 'otpauth://totp/Test?secret=' + secretCode + '&issuer=Cognito-TOTP-MFA';
                        //             console.log('シークレットコード: ' + secretCode);
                        //             // qrcode.generate(url, {small: true});

                        //             // let _this = this;
                        //             // let getValue = 'Google AuthenticatorでQRコードを読み取り、ワンタイムパスワードを入力してください';
                        //             // prompt.get([getValue], function (err, result) {
                        //             //     challengeAnswer = result[getValue];
                        //             //     cognitoUser.verifySoftwareToken(result[getValue], 'My TOTP device', _this);
                        //             //     console.log('2回目からはQRコードの読み取りは不要です');
                        //             // });
                        //             callbacks.onFailure('secretCode: ' + secretCode);
                        //         },
                        //         onFailure: function(err){
                        //             console.log('associateSoftwareToken#onFailure');
                        //             console.log(err);
                        //             // ログイン失敗時
                        //             callbacks.onFailure('Your authentication information is incorrect.');
                        //         }
                        //     }
                        // );
                    },
                    mfaRequired: function (challengeName, challengeParameters) {
                        // ワンタイムパスワード要求時に発生
                        // Google Authenticatorなどからワンタイムパスワードを入力して認証します
                        console.log('mfaRequired');
                        console.log(challengeName);
                        console.log(challengeParameters);
                        callbacks.onFailure('mfaRequired');
                    },
                    totpRequired: function (challengeName, challengeParameters) {
                        // ワンタイムパスワード要求時に発生
                        // Google Authenticatorなどからワンタイムパスワードを入力して認証します
                        console.log('totpRequired');
                        console.log(challengeName);
                        console.log(challengeParameters);
                
                        cognitoUser.sendMFACode(authcode, this, 'SOFTWARE_TOKEN_MFA');
                        // let _this = this
                        // let getValue = 'Google Authenticatorのワンタイムパスワードを入力してください';
                        // prompt.get([getValue], function (err, result) {
                        //     var challengeAnswer = result[getValue];
                        //     cognitoUser.sendMFACode(challengeAnswer, _this, 'SOFTWARE_TOKEN_MFA');
                        // });
                    },
                    customChallenge: function(challengeParameters) {
                        console.log('customChallenge');
                        console.log(challengeParameters);
                        callbacks.onFailure('customChallenge');
                    },
                    selectMFAType: function (challengeName, challengeParameters) {
                        console.log('selectMFAType');
                        console.log(challengeName);
                        console.log(challengeParameters);
                        callbacks.onFailure('selectMFAType');
                    },
                    onFailure: function (err) {
                        console.log(err);
                        // ログイン失敗時
                        callbacks.onFailure('Your authentication information is incorrect.');
                    },
                });
            } catch (err) {
                console.log('cognitoUser.authenticateUser catch');
                console.log(err);
                callbacks.onFailure('System Error; Contact your system administrator.');
            }
            
            await BackendService.refreshCsrfToken();
        },
        logout: async () => {
            if (cognitoUser) {
                cognitoUser.signOut();
            }
            await BackendService.refreshCsrfToken();
            setUserName('');
            setIdToken('');
            setCognitoUser(undefined);
        },
        init: ()=> {
            console.log("UserContextProvider-init");
            setUserName('');
            setIdToken('');
            setCognitoUser(undefined);
        },

        userName: userName,
        idToken: idToken,
        isLoggedIn: idToken !== '',

        isAvailableFunc:  (target: string, funcList: Function[]) => {
            return funcList.some((funcList) => funcList.functionId == target);
        },

        availableFunction: async (idToken: string, callbacks: IFunctionCallback) =>{
            BackendService.availableFunction(idToken)
            .then(response => {
                console.log("BackendService.availableFunction :then userName[" + userName + "], idToken[" + idToken + "]");
                console.log(response);

                // ステータス = 0 以外ならエラーメッセージ
                if(response.status == '0'){
                    if(response.functionList != null) {
                        const funcList = response.functionList;
                        callbacks.onFuncSuccess(funcList);
                    } 
                }
                else {
                    callbacks.onFuncFailure('System Error; Contact your system administrator （No systems available.）');
                }
            })
            .catch(error => {
                console.log("BackendService.availableFunction :catch");
                console.log(error);
                callbacks.onFuncFailure('System Error; Contact your system administrator.');
            });
        },
    };

    return (
        <UserContext.Provider value={contextValue}>
            {children}
        </UserContext.Provider>
    );
};